import classNames from "classnames"
import React, { useCallback, useEffect } from "react"
import { Nav, NavItem, NavLink } from "reactstrap"
import { useLocation, useNavigate } from "react-router-dom"

export type IndexType = "list-ul" | "grid-alt"
const indexes: IndexType[] = ["list-ul", "grid-alt"]

interface GridTableToggleProps {
  activeTab: IndexType
  setActiveTab: (tab: IndexType) => void
}

const GridTableToggle: React.FC<GridTableToggleProps> = ({
  activeTab,
  setActiveTab,
}) => {
  const location = useLocation()
  const navigate = useNavigate()

  const searchParams = new URLSearchParams(location.search)
  const currentView: IndexType =
    (searchParams.get("view") as IndexType) || ("list-ul" as IndexType)

  const onChangeViewHandler = useCallback(
    (view: IndexType) => {
      searchParams.set("view", view)
      navigate({ search: searchParams.toString() })
      setActiveTab(view)
    },
    [setActiveTab]
  )

  useEffect(() => {
    setActiveTab(currentView)
  }, [])

  return (
    <div className="flex-grow-1 d-flex justify-content-end align-items-center w-100">
      <Nav
        className="product-view-nav justify-content-end mt-3 mt-sm-0 gap-0.5"
        pills
      >
        {indexes.map(index => (
          <NavItem key={index}>
            <NavLink
              className={classNames({
                active: activeTab === index,
              })}
              onClick={() => onChangeViewHandler(index)}
              style={{
                borderRadius: "0px",
                height: "36px",
                width: "36px",
              }}
            >
              <i className={`bx bx-${index}`} />
            </NavLink>
          </NavItem>
        ))}
      </Nav>
    </div>
  )
}

export default GridTableToggle
